import React, { useEffect, useState } from "react";
import "./users.scss";
import sidebarActivePage from "../../stores/sidebarActivePage";
import TwoBreadcrumb from "../../components/breadcrumbs/TwoBreadcrumb";
import { Box, Paper, Tab } from "@mui/material";
import usersStore from "../../stores/usersStore";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import AllUserTabs from "./userTabs/AllUserTabs";
import ActiveUserTab from "./userTabs/ActiveUserTab";
import BannedUserTab from "./userTabs/BannedUserTab";
import DeletedUserTab from "./userTabs/DeletedUserTab";
import UserFilter from "./userFilter/UserFilter";

const Users = () => {
  const SidebarActivePage = sidebarActivePage();
  const UsersStore = usersStore();
  const [allUser, setAllUser] = useState(0);
  const [activeUser, setActiveUser] = useState(0);
  const [bannedUser, setBannedUser] = useState(0);
  const [deletedUser, setDeletedUser] = useState(0);

  const [dataLoading, setDataLoading] = useState(true);

  useEffect(() => {
    SidebarActivePage.setIsActive({ setPage: "Users" });
  }, []);

  useEffect(() => {
    if (!UsersStore.isLoading) {
      const all = [];
      const active = [];
      const banned = [];
      const deleted = [];
      if (UsersStore.allUser) {
        UsersStore.allUser.map((user, index) => {
          all.push(user.status);
          if (user.status === 0) {
            active.push(user.status);
          }
          if (user.status === 1) {
            banned.push(user.status);
          }
          if (user.status === 2) {
            deleted.push(user.status);
          }
        });
      }

      setAllUser(all.length);
      setActiveUser(active.length);
      setBannedUser(banned.length);
      setDeletedUser(deleted.length);
      setDataLoading(false);
    }
  }, [UsersStore.isLoading]);

  const [activeTab, setActiveTab] = React.useState("1");

  const handleChangeTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [gender, setGender] = useState("");
  const [status, setStatus] = useState("");
  const [staringDate, setStaringDate] = useState(null);
  const [endingDate, setEndingDate] = useState(null);

  return (
    <div className="users">
      <div className="heading">Users</div>
      <TwoBreadcrumb mainName="Users" mainLink="users" activeName="List" />
      {activeTab === "1" && (
        <div className="filter-content">
          <UserFilter
            userName={userName}
            setUserName={setUserName}
            email={email}
            setEmail={setEmail}
            phoneNo={phoneNo}
            setPhoneNo={setPhoneNo}
            gender={gender}
            setGender={setGender}
            status={status}
            setStatus={setStatus}
            staringDate={staringDate}
            setStaringDate={setStaringDate}
            endingDate={endingDate}
            setEndingDate={setEndingDate}
          />
        </div>
      )}
      <Paper sx={{ width: "100%", mb: 2, mt: 4 }}>
        <TabContext value={activeTab}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChangeTab}
              aria-label="lab API tabs example"
              className="tab-list"
              variant="scrollable"
              // scrollButtons
              // allowScrollButtonsMobile
            >
              <Tab
                className="tab"
                label={
                  <p className={activeTab === "1" ? "all-user" : ""}>
                    All <span className="all">{allUser}</span>
                  </p>
                }
                value="1"
              />
              <Tab
                className="tab"
                label={
                  <p className={activeTab === "2" ? "active-user" : ""}>
                    Active <span className="active">{activeUser}</span>
                  </p>
                }
                value="2"
              />
              <Tab
                className="tab"
                label={
                  <p className={activeTab === "3" ? "banned-user" : ""}>
                    Banned <span className="banned">{bannedUser}</span>
                  </p>
                }
                value="3"
              />
              <Tab
                className="tab"
                label={
                  <p className={activeTab === "4" ? "deleted-user" : ""}>
                    Deleted <span className="deleted">{deletedUser}</span>
                  </p>
                }
                value="4"
              />
            </TabList>
          </Box>
          <TabPanel value="1" sx={{ p: 0 }}>
            <AllUserTabs
              dataLoading={dataLoading}
              userName={userName}
              email={email}
              phoneNo={phoneNo}
              gender={gender}
              status={status}
              staringDate={staringDate}
              endingDate={endingDate}
            />
          </TabPanel>
          <TabPanel value="2" sx={{ p: 0 }}>
            <ActiveUserTab dataLoading={dataLoading} />
          </TabPanel>
          <TabPanel value="3" sx={{ p: 0 }}>
            <BannedUserTab dataLoading={dataLoading} />
          </TabPanel>
          <TabPanel value="4" sx={{ p: 0 }}>
            <DeletedUserTab dataLoading={dataLoading} />
          </TabPanel>
        </TabContext>
      </Paper>
    </div>
  );
};

export default Users;
